<template>
    <form :method="method" :action="action">
        <form-element
            v-for="(d, uniqueName) in data"
            :key="uniqueName"
            :error-color="aspectDefault.errorColor"
            :name="d.name"
            :unique-name="uniqueName"
            :label="d.label"
            :type="d.type"
            :options="d.options"
            v-model="d.value"
            :placeholder="d.placeholder"
            :editable="d.editable"
            :tooltip="d.tooltip"
            :oldValue="d.oldValue"
            :required="d.required"
            :visible.sync="d.visible"
            :visibility-conditions="d.visibilityConditions"
            :form-fields="data"
            :submitted="submitted"
            :validations="d.validations"
            :translations="translationsDefault"
            :aspect="aspectDefault"
            :location="locationDefault"
            :err.sync="d.error"
            :hidden="d.hidden"
            :force-status-icon="forceStatusIcon"
            :response.sync="d.response"
            :refresh-index="d.refreshIndex"
            :tooltip-position="tooltipPosition"
            :submit-hidden-fields="submitHiddenFields"
            :show-icons-in-inputs="showIconsInInputs"
            :subfields="d.subfields"
            :upload-url="d.uploadUrl"
            :with-address="d.withAddress"
            :with-prefix="d.withPrefix"
            :phone-prefix="d.phonePrefix"
            :cooperative="d.cooperative"
            :cooperative-data="d.cooperativeData"
            @change="handleChange"
        ></form-element>
        <button type="button" class="btn btn-secondary" v-if="(back != '')" @click="goBack" v-html="translationsDefault.back"></button>
        <div :class="aspectDefault.submitWrapper">
            <button :class="aspectDefault.submitClass" @click="submit" :disabled="loading" v-html="buttonText"></button>
            <button v-if="action2" :class="aspectDefault.submitClass2" @click="submit2" :disabled="loading2" v-html="buttonText2"></button>
        </div>
        <div class="form-results">
            <p id="global-errors" :class="errorClass+' alert alert-danger mt-3'" v-html="globalError"></p>
            <p id="success-message" :class="successClass+' alert alert-success mt-3'">{{successMessage}}</p>
        </div>
    </form>
</template>

<script>
    import axios from 'axios';
    const objectToFormData = require('object-to-formdata')
    export default {
        name: "form-helper",
        props: {
            data: {type: Object, required: true},
            method: {type: String, default: "post" },
            action: {type: String, default: "" },
            action2: {type: String, default: null },
            success: {type: String, default: "" },
            back: {type: String, default: "" },
            translations: {type: Object, default: function(){ return {}; }},
            aspect: {type: Object, default: function(){ return {}; }},
            location: {type: Object, default: function(){ return {}; }},
            forceStatusIcon: {type: Boolean, default: false},
            tooltipPosition: { type:String, default: "bottom" },
            submitHiddenFields: {type: Boolean, default: false},
            showIconsInInputs: { type:Boolean, default: true }
        },
        computed: {
            buttonText(){
                if(this.loading){
                    return this.spinner+this.translationsDefault.loadingText;
                }else{
                    return this.translationsDefault.submit
                }
            },
            buttonText2(){
                if(this.loading2){
                    return this.spinner+this.translationsDefault.loadingText;
                }else{
                    return this.translationsDefault.submit2
                }
            }
        },
        data: function(){
            return {
                spinner: '<i class="fas fa-spinner fa-spin" style="margin-right: 10px"></i>',
                loading: false,
                loading2: false,
                submitted: false,
                globalError: "",
                successMessage: "",
                errorClass: "d-none",
                successClass: "d-none",
                aspectDefault: {
                    errorColor: "#921a2d",
                    leftColumnWrapperClass: "col-md-3",
                    rightColumnWrapperClass: "col-md-9",
                    rightColumnWrapperFullWidthClass: "col-md-12",
                    rowClass: "row",
                    separatorClass: "h3 block-title widget-title title-small",
                    formFieldWrapperClass: "form-group",
                    formFieldClass: "form-control",
                    errorClasses: "col-md-9 offset-md-3 error-text",
                    fieldColumnAThird: "col-sm-4",
                    fieldColumnTwoQuarters: "col-sm-8",
                    fieldColumnAQuarter: "col-sm-4",
                    submitWrapper: "form-group register-button text-right",
                    submitClass: "btn btn-primary",
                    submitClass2: "btn btn-secondary",
                },
                locationDefault: {
                    countries: '',
                    regions: '',
                    provinces: '',
                    cities: ''
                },
                translationsDefault: {
                    submit: "SUBMIT",
                    submit2: "SUBMIT",
                    back: "INDIETRO",
                    requiredWarning: "This field is required but not filled.",
                    alphabeticalWarning: "This field must be alphabetical",
                    numericWarning: "This field must be a number",
                    emailWarning: "This field must be an email",
                    phoneWarning: "This field must be a phone",
                    websiteWarning: "This field must be a website",
                    minLenghtWarningPrefix: "This field length is ",
                    minLenghtWarningSuffix: " characters minimum",
                    maxLenghtWarningPrefix: "This field length is ",
                    maxLenghtWarningSuffix: " characters maxium",
                    minWarningPrefix: "The minimum value for this field is ",
                    minWarningSuffix: "",
                    maxWarningPrefix: "The maximum value for this field is ",
                    maxWarningSuffix: "",
                    pickDay: "Pick the day",
                    pickMonth: "Pick the month",
                    pickYear: "Pick the year",
                    adultWarning: "You must be an adult",
                    add: "Add",
                    remove: "Remove",
                    sendCode: "Send code",
                    insertCodePlaceholder: "Insert the code received on your phone",
                    validateCode: "Validate code",
                    pleaseInsertRightCodeWarning: "Please insert the right code to validate your phone",
                    plaseValidateYourPhoneWarning: "Your phone number must be validated",
                    pickCountry: "Select the country",
                    pickRegion: "Select the region",
                    pickProvince: "Select the province",
                    pickCity: "Select the city",
                    cfWarning: "This field must be a valid fiscal code",
                    vatWarning: "This field must be a vat",
                    globalErrors: "Some errors occours, please review your inputs",
                    successMessage: 'Data saved successfully',
                    notStrongPassword: 'This password is not strong',
                    fieldsNotEquals: 'The two fields are not equal',
                    fieldsNotBigger: 'The field is not bigger than the other field',
                    fieldsNotSmaller: 'The field is not smaller than the other field',
                    validationServerError: 'Server validation is went wrong',
                    depenencyError: 'Please fill before the previous fields',
                    addMultipleSelectLabel: 'Add row',
                    atLeastOneOptionWarning: "You need to select at least one option",
                    loadingText: "LOADING",
                    placeholderAddress: "Street name and number",
                    placeholderZip: "Type your post code",
                    cooperativeCommentPlaceholder: "Put your comments here",
                }
            }
        },
        watch: {
            translations: {
                deep: true,
                handler(){
                    this.assignTranslationsToDefault()
                }
            }
        },
        mounted(){
            this.assignTranslationsToDefault();
            Object.keys(this.aspectDefault).forEach(key => {
                if(this.aspect && this.aspect[key] && this.aspect[key].length > 0){
                    this.aspectDefault[key] = this.aspect[key]
                }
            });
            Object.keys(this.locationDefault).forEach(key => {
                if(this.location && this.location[key] && this.location[key].length > 0){
                    this.locationDefault[key] = this.location[key]
                }
            });
        },
        methods: {
            handleChange(uniqueName){
                this.$emit("change", uniqueName);
            },
            assignTranslationsToDefault(){
                Object.keys(this.translationsDefault).forEach(key => {
                    if(this.translations && this.translations[key] && this.translations[key].length > 0){
                        this.translationsDefault[key] = this.translations[key]
                    }
                });
            },
            goBack(){
              location.href = this.back
            },
            submit(event){
                event.preventDefault()
                this.submitted = true
                this.submitRequest(this.action, 1)
                return false
            },
            submit2(event){
                event.preventDefault()
                this.submitted = true
                this.submitRequest(this.action, 2)
                return false
            },
            async prepareFormData(action, data){
                var formData = objectToFormData(data,{
                    indices: true
                });
                return formData;
            },
            async submitRequest(action, number){
                if(!(this.loading||this.loading2)){
                    this.globalError = "";
                    this.errorClass = "d-none";
                    if(number == 1){ this.loading = true; }
                    if(number == 2){ this.loading2 = true; }
                    var errorPresent = false;
                    var dataToSend = {};
                    var versions = {};
                    for (const key of Object.keys(this.data)) {
                        if(this.data[key].visible || this.submitHiddenFields){
                            if(this.data[key].name && this.data[key].type != "separator"){
                                dataToSend[this.data[key].name] = this.data[key].value;
                                if(this.data[key].cooperative){
                                    versions[this.data[key].name] = this.data[key].cooperativeData;
                                }
                            }
                            if(this.data[key].error == true && number == 1){
                                errorPresent = errorPresent || true;
                            }
                        }
                    }
                    if(!errorPresent){
                        dataToSend["cooperativeData"]=versions;
                        var d  = await this.prepareFormData(action, dataToSend);
                        return axios({
                                url:number==1?this.action:this.action2,
                                method:this.method,
                                data: d,
                                //versions: versions,
                                header: { 'Content-Type': 'multipart/form-data'}
                            })
                            .then((r)=>{
                                if(this.success == '#'){
                                  location.href = '';
                                }else if(this.success == '#returned'){
                                    location.href = r.data;
                                }else if(this.success.length > 0){
                                  location.href = this.success;
                                }else{
                                  this.globalError = '';
                                  this.successClass = 'd-block';
                                  this.errorClass = 'd-none';
                                  this.successMessage = (r && r.data && r.data.length > 0)?r.data:this.translations.successMessage;
                                  this.loading = false;
                                  this.loading2 = false;
                                }
                            })
                            .catch((e)=>{
                                this.successMessage = '';
                                this.successClass = 'd-none';
                                this.errorClass = 'd-block';
                                this.globalError = (e.response && e.response.data && e.response.data.length > 0)?e.response.data:((e.response.status == 401 && e.request.statusText != null && e.request.statusText.length > 0)?e.request.statusText:this.translations.globalErrors);
                                this.loading = false;
                                this.loading2 = false;
                            });
                    }else{
                        this.globalError = this.translationsDefault.globalErrors;
                        this.successMessage = '';
                        this.successClass = 'd-none';
                        this.errorClass = 'd-block';
                        this.loading = false;
                        this.loading2 = false;
                    }
                }
            },
        }
    }
</script>
